import { useContext } from "react"
import { PrintContext } from "./context"
import { UsePrintCartReturnType } from "../types"

const usePrintCart = (): UsePrintCartReturnType => {
  const printContext = useContext(PrintContext)

  if (printContext === null) {
    throw new Error("Print cart context have to be provided")
  }

  return {
    ...printContext,
  }
}

export { usePrintCart }
